import React, { useEffect, useState } from "react";
import axios from "axios";
import logo from "../../assets/images/logo.png";
import { toast } from "sonner";

import PlanCard from "../../components/SubscriptionCard";
import SpecialPlans from "../../components/SpecialPlans";
import CancellationModal from "../../components/CancellationModal";
import ReferralModal from "../../components/ReferralModal";
import instance from "../../redux/actions/AxiosInstance/authenticated";

const features = {
  basic: ["1500 Credits", "Priority support"],
  premium_monthly: ["Unlimited Product Scans", "Priority support"],
  premium_yearly: ["Unlimited Product Scans", "Priority support", "3 days trial"],
  default: ["Priority support"],
};

const PaymentTables = () => {
  const planType = "chargebee";
  const [plansData, setPlansData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [activeTab, setActiveTab] = useState('regular');
  const accessToken = localStorage.getItem("accessToken");

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [planToCancel, setPlanToCancel] = useState(null);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [selectedReferralSource, setSelectedReferralSource] = useState(null);

  //   const newUser = useSelector((state) => state.auth.newUser);

  const getPlanDetails = async () => {
    try {
      const res = await instance.get(
        process.env.REACT_APP_BASE_URL + "/subscription/plans"
      );
      if (res.data.data.length > 0) {
        setPlansData(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCheckoutURL = async (plan_id, coupon = null) => {
    try {
      const payload = { plan_id };
      if (coupon) {
        payload.coupon = coupon;
      }
      
      // Add referral source if available
      if (selectedReferralSource) {
        payload.referral_source_id = selectedReferralSource.id;
      }
      
      const res = await instance.post(
        process.env.REACT_APP_BASE_URL +
          (planType === "whop"
            ? "/whop/checkout-url"
            : "/chargebee/checkout-session"),
        payload
      );
      return res.data;
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    }
  };

  useEffect(() => {
    // fetch payment options
    if (!accessToken) {
      toast.error("Create an Account first!");
      window.location.href = "/signup";
    }
    getPlanDetails();
    
    // Check if referral modal should be shown
    const referralSkipped = localStorage.getItem("referralModalSkipped");
    const savedReferralSource = localStorage.getItem("selectedReferralSource");
    
    if (!referralSkipped && !savedReferralSource) {
      setShowReferralModal(true);
    } else if (savedReferralSource) {
      try {
        setSelectedReferralSource(JSON.parse(savedReferralSource));
      } catch (error) {
        console.error("Error parsing saved referral source:", error);
      }
    }
    
    // const userDetails = axios.get(process.env.REACT_APP_BASE_URL + "/user/details", {
    //     headers: {
    //         Authorization: `Bearer ${accessToken}`,
    //     },
    // });

    // if(userDetails.data?.subscritptionActive){
    //     setActivePriceId(userDetails.data.planId)
    // }
  }, []);

  const handleStartTrial = async (plan) => {
    setIsLoading(plan.id);
    if (!isLoading) {
      const res = await getCheckoutURL(plan.id, plan.coupon);
      if (res) {
        window.location.href = res.purchase_url;
      }
    }
    setIsLoading(null);
  };

  const handleCancellationSuccess = () => {
    // Refresh plans data after successful cancellation
    getPlanDetails();
  };

  const handleReferralSourceSelect = (referralSource) => {
    setSelectedReferralSource(referralSource);
  };

  const handleReferralModalClose = () => {
    setShowReferralModal(false);
  };
  return (
    <div className="bg-primary-bg">
      <div
        className={`px-5 py-3.5 flex  w-full justify-between items-center font-Inter`}
      >
        <div className="flex items-center space-x-3 w-[60%] max-w-[240px]">
          <img src={logo} className="w-3/4 h-auto" />
        </div>
      </div>
      <hr className="h-[1.15px] mt-1 border-primary/20" />
      
      <div className="flex items-center justify-center" style={{ minHeight: "calc(100vh - 70px)" }}>
        {activeTab === 'regular' ? (
            <div className="flex flex-col md:flex-row justify-center items-stretch space-x-0 md:space-x-8 space-y-8 md:space-y-0 p-8">
              {plansData.length > 0 &&
                plansData.map((plan, index) => {
                  if (
                    plan.id !== process.env.REACT_APP_PREMIUM_PLAN_ID &&
                    plan.id !== process.env.REACT_APP_PREMIUM_YEARLY_PLAN_ID &&
                    plan.id !== process.env.REACT_APP_BASIC_PLAN_ID
                  ) {
                    return null;
                  }
                  
                  return (
                    <PlanCard
                      key={index}
                      planId={plan?.id}
                      title={
                        plan?.billing_period === 30 
                          ? "Monthly Plan" 
                          : plan?.billing_period === 365 
                          ? "Annual Plan" 
                          : "Premium Plan"
                        }
                      price={plan?.renewal_price}
                      features={
                        plan.id === process.env.REACT_APP_PREMIUM_PLAN_ID
                          ? features.premium_monthly
                          : plan.id === process.env.REACT_APP_PREMIUM_YEARLY_PLAN_ID
                          ? features.premium_yearly
                          : plan.id === process.env.REACT_APP_BASIC_PLAN_ID
                          ? features.basic
                          : features.default
                      }
                      isPopular={
                        plan.id === process.env.REACT_APP_PREMIUM_PLAN_ID
                          ? true
                          : false
                      }
                      isActive={plan?.active}
                      isLoading={isLoading}
                      onStartTrial={() => handleStartTrial(plan)}
                      onCancel={() => {
                        setPlanToCancel(plan?.id);
                        setShowCancelModal(true);
                      }}
                      isYearly={plan?.id === process.env.REACT_APP_PREMIUM_YEARLY_PLAN_ID}
                      trialAvailable={plan?.id === process.env.REACT_APP_PREMIUM_YEARLY_PLAN_ID}
                      onApplyCoupon={() => setActiveTab('special')}
                    />
                  );
                })}
            </div>
        ) : (
          <div className="py-8">
            <div className="px-6">
              <button
                onClick={() => setActiveTab('regular')}
                className="text-primary underline text-sm font-medium hover:text-primary/80 transition-colors duration-200"
              >
                ← Back to Plans
              </button>
            </div>
            <SpecialPlans onStartTrial={handleStartTrial} />
          </div>
        )}
      </div>

      <CancellationModal
        showModal={showCancelModal}
        onClose={() => {
          setShowCancelModal(false);
          setPlanToCancel(null);
        }}
        planId={planToCancel}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        onSuccess={handleCancellationSuccess}
      />

      <ReferralModal
        isOpen={showReferralModal}
        onClose={handleReferralModalClose}
        onSelectCreator={handleReferralSourceSelect}
      />
    </div>
  );
};

export default PaymentTables;
